import React from 'react';
import { Heart } from 'lucide-react';

interface StartScreenProps {
  onStart: () => void;
}

export const StartScreen: React.FC<StartScreenProps> = ({ onStart }) => {
  return (
    <div className="z-50 flex flex-col items-center justify-center animate-fade-in">
      <button
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering background clicks
          onStart();
        }}
        className="group relative px-10 py-5 bg-white text-red-500 font-strong text-3xl md:text-5xl rounded-full shadow-2xl transition-all duration-300 hover:scale-105 hover:bg-red-500 hover:text-white hover:shadow-red-200/50 active:scale-95 flex items-center gap-4 border-2 border-red-100"
      >
        <Heart className="w-8 h-8 fill-current animate-pulse" />
        <span>Be My Valentine</span>
        <Heart className="w-8 h-8 fill-current animate-pulse" />
        
        {/* Subtle glow effect */}
        <div className="absolute inset-0 rounded-full bg-red-400 opacity-0 group-hover:opacity-20 blur-lg transition-opacity duration-300 pointer-events-none" />
      </button>
      
      <p className="mt-8 text-red-400 font-sub tracking-[0.3em] text-sm uppercase font-bold animate-pulse">
        Click to Open
      </p>
    </div>
  );
};